import { render, staticRenderFns } from "./ChatMessageCard.vue?vue&type=template&id=52b4dcfa&scoped=true&"
import script from "./ChatMessageCard.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageCard.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessageCard.vue?vue&type=style&index=0&id=52b4dcfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b4dcfa",
  null
  
)

export default component.exports